import { Observable } from 'rxjs';
import { CarouselResponse } from '../models/carousel.model';

export abstract class CarouselRepository {
    abstract getCarouselData(): Observable<CarouselResponse>;
}
